module.exports = __webpack_public_path__ + "static/media/share-icon3.41054844.svg";